import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { HttpParameter, KeyValue } from '../datatypes/misc';
import { AppConfig } from '../app.config';

@Injectable({ providedIn: 'root' })

export class HttpClientHelper {
    private body: string;
    // Use type object as no predefined type for option and ducumentaion is not clearly explaiend
    // read more https://angular.io/api/common/http/HttpClient#get
    private options: Object;
    private url: string;
    private headers: HttpHeaders;


    constructor(private httpClient: HttpClient) {}

    httpGet(httpHelperParams: HttpParameter): Observable<any> {
        this.initialise(httpHelperParams);
        return this.httpClient.get(this.getUrl(), this.getOptions());
    }

    httpPost(httpHelperParams: HttpParameter): Observable<any> {
        this.initialise(httpHelperParams);
        return this.httpClient.post(this.getUrl(), this.getBody(), this.getOptions());
    }

    httpPut(httpHelperParams: HttpParameter): Observable<any> {
        this.initialise(httpHelperParams);
        return this.httpClient.put(this.getUrl(), this.getBody(), this.options);
    }

    httpDelete(httpHelperParams: HttpParameter): Observable<any> {
        this.initialise(httpHelperParams);
        return this.httpClient.delete(this.getUrl(), this.getOptions());
    }

    private initialise(httpHelperParams: HttpParameter) {
        this.url = AppConfig.getUrl(httpHelperParams.urlKey);

        if (this.isArrayPopulated(httpHelperParams.urlParams)) {
            const urlParams = httpHelperParams.urlParams.join('/');
            this.url = this.url + urlParams;
        }

        if (httpHelperParams.body) {
            this.body = JSON.stringify(httpHelperParams.body);
        }

        if (httpHelperParams.options) {
            this.options = httpHelperParams.options;
        } else {
            this.options = { headers: this.headers};
        }
    }

    private getBody(): string {
        return this.body;
    }

    private getUrl(): string {
        return this.url;
    }

    private getOptions(): Object {
        return this.options;
    }

    private isArrayPopulated(arr: string[] | KeyValue[]): boolean {
        return (arr !== null && typeof arr !== 'undefined' && arr.length > 0);
    }
}
